import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const SeekingInfo = () => {
  const [seekingInfo, setSeekingInfo] = useState({
    seekingMen: false,
    seekingWomen: false,
    relationshipGoals: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/seeking-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No seeking info found. Please set your seeking info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch seeking info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const seekingData = data.reduce((acc, item) => {
            if (item.question_text === 'Who are you seeking?') {
              acc.seekingMen = item.answer_text.includes('Men');
              acc.seekingWomen = item.answer_text.includes('Women');
            }
            if (item.question_text === 'Relationship Goals')
              acc.relationshipGoals = item.answer_text;
            return acc;
          }, {});
          setSeekingInfo(seekingData);
        }
      })
      .catch((error) => {
        console.error('Error fetching seeking info:', error);
        setMessage('Error fetching seeking info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = { ...seekingInfo };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/seeking-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update seeking info');
      }

      setSeekingInfo(payload);
      setMessage('Seeking info updated successfully.');

      setTimeout(() => {
        navigate('/career-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting seeking info:', error);
      setMessage('Failed to update seeking info.');
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSeekingInfo({
      ...seekingInfo,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Seeking Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                Who are you seeking? (Selecting both is applicable)
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="seekingMen"
                    checked={seekingInfo.seekingMen}
                    onChange={handleChange}
                    className="form-checkbox"
                  />
                  <span className="ml-2">Men</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name="seekingWomen"
                    checked={seekingInfo.seekingWomen}
                    onChange={handleChange}
                    className="form-checkbox"
                  />
                  <span className="ml-2">Women</span>
                </label>
              </div>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                Relationship Goals
              </label>
              <select
                name="relationshipGoals"
                value={seekingInfo.relationshipGoals || ''}
                onChange={handleChange}
                className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black sm:text-sm rounded-md"
                required
              >
                <option value="">Select your relationship goals</option>
                <option value="Casual hookup">Casual hookup</option>
                <option value="A date or two">A date or two</option>
                <option value="Holiday fling">Holiday fling</option>
                <option value="Short-term (few months)">
                  Short-term (few months)
                </option>
                <option value="Long-term (1+ year)">Long-term (1+ year)</option>
              </select>
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/sex-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SeekingInfo;
